export class CityPath {
    constructor(path, region) {
        this.path = path;
        this.region = region;
    }
}